import {useCallback, useLayoutEffect} from "react";

type WindowSize = {
    width: number
    height: number
}

const windowSize = (): WindowSize => ({
    width: window.innerWidth,
    height: window.innerHeight
})

export const useWindowSize = (callback: (size: WindowSize) => void) => {
    const handleResize = useCallback(() => {
        callback(windowSize())
    }, [callback])

    useLayoutEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);
}
